import { DataKey, ErrorKey } from '../../Store/callAPI/allAPIs';
import { toast } from 'react-toastify';
import { removeAPIDataAction } from '../../Store/callAPI/actions';

const ShowErrMsg = (apiData, storekey) => {
    if (apiData?.[DataKey]?.statusCode) {
        let errMsg;
        if (apiData?.[DataKey]?.errorMessage?.length > 0) {
            errMsg = `${apiData[DataKey]?.statusCode} error. ${apiData[DataKey]?.errorMessage[0]}`;
        } else if (apiData?.[DataKey]?.warnings?.length > 0) {
            errMsg = apiData[DataKey]?.warnings[0];
        } else {
            errMsg = `${apiData?.[DataKey]?.statusCode} error. Error in requesting data`;
        }

        toast.error(errMsg);
        removeAPIDataAction(storekey);
    } else if (apiData?.[ErrorKey]) {
        toast.error(apiData?.[ErrorKey]);
        removeAPIDataAction(storekey);
    }
};
const GetErrMsg = (apiData) => {
    let errMsg;
    if (apiData?.[DataKey]?.errorMessage?.length > 0) {
        errMsg = apiData[DataKey]?.errorMessage[0];
    } else if (apiData?.[DataKey]?.warnings?.length > 0) {
        errMsg = apiData[DataKey]?.warnings[0];
    } else {
        errMsg = 'Error in fetching data';
    }
    return errMsg;
};
export { ShowErrMsg, GetErrMsg };
